
import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import AddressInfo from '@/features/shipment-history/components/details/shipmentDetails/blocks/AddressInfo.vue';
import EcommerceInfo from '@/features/shipment-history/components/details/shipmentDetails/blocks/EcommerceInfo.vue';
import AdditionalInfo from '@/features/shipment-history/components/details/shipmentDetails/blocks/AdditionalInfo.vue';
import PackageDetails from '@/features/shipment-history/components/details/shipmentDetails/blocks/PackageDetails.vue';
import CustomDeclaration from '@/features/shipment-history/components/details/shipmentDetails/blocks/CustomDeclaration.vue';
import SupportingDocumentsHistory from '@/features/shipment-history/components/details/shipmentDetails/blocks/SupportingDocumentsHistory.vue';
import { HistoryItemType } from '@/features/shipment-history/types';
import {
  deleteShipments,
  duplicateShipmentAction,
  EncodedMapImages,
  getEstimate,
  reprintLabel,
  reschedulePickupAction,
} from '@/features/shipment-history/helpers';
import { modifyOrReturnShipment } from '@/features/shipment/helpers/createShipment';
import ShipmentDetailsSkeleton from '@/features/shipment-history/components/details/shipmentDetails/ShipmentDetailsSkeleton.vue';
import eventBus from '@/features/common/eventBus';
import eventNames from '@/features/common/constants/events';
import { showWarningAlertDialog } from '@/features/common/helpers';

@Component({
  components: {
    AddressInfo,
    EcommerceInfo,
    AdditionalInfo,
    PackageDetails,
    CustomDeclaration,
    SupportingDocumentsHistory,
    ShipmentDetailsSkeleton,
  },
})
export default class ShipmentDetails extends Vue {
  @Prop({ default: true }) showTrackingNum!: boolean;

  @Prop({ required: true }) item!: HistoryItemType;

  @Prop({ default: false }) isLoading!: boolean;

  @Prop({ default: '' }) carrierTrackingNumber!: string;

  @Prop({ default: false }) large!: boolean;

  @Prop({ default: () => ({}) }) encodedMapImages!: EncodedMapImages;

  private reprintLabel(): void {
    reprintLabel([this.item]);
  }

  private editShipment(): void {
    if (this.item.deleted) {
      showWarningAlertDialog(this.$t('history.alertDialog.cannotModifyDeletedShipment') as string);
      return;
    }

    this.$emit('close');
    modifyOrReturnShipment(
      this.item.trackingNumber,
      'modify',
    );
  }

  private returnShipment(): void {
    if (this.item.deleted) {
      showWarningAlertDialog(this.$t('history.alertDialog.cannotModifyDeletedShipment') as string);
      return;
    }

    this.$emit('close');
    modifyOrReturnShipment(
      this.item.trackingNumber,
      'return',
    );
  }

  private deleteShipments(): void {
    deleteShipments([this.item]);
    this.$emit('close');
  }

  private getEstimate(): void {
    this.$emit('close');
    getEstimate(this.item);
  }

  private duplicateShipment(): void {
    this.$emit('close');
    duplicateShipmentAction(this.item);
  }

  private async reschedulePickup(): Promise<void> {
    this.$emit('close');

    const isSuccessful = await reschedulePickupAction(this.item);
    if (!isSuccessful) return;

    eventBus.$emit(eventNames.CONTINUE_SCHEDULE_PICKUP, this.item);
  }
}
